import { defineMessage } from 'services/localization';

export const messages = {
    addPayer: defineMessage('add_a_payer'),
    bubbleText: defineMessage('send_payment_via_airwallex'),
    twoFaDisabled: defineMessage('fa_is_not_enabled'),
    twoFaEnabled: defineMessage('fa_is_active'),
    twoFaDisabledTitle: defineMessage('fa_is_required_to_send_payments_with_airwallex'),
    stepDescription: defineMessage('payers_can_check_airwal_irwallex_for_processing'),
};
